<template>
  <div class="lsg-page lsg-trade__page trade_page">
    <div class="lsg-trade" v-if="property">
      <div class="main__header">
        <div class="main__header__item left">
          <h1>{{ getName(property.contract, property) }}</h1>
        </div>
      </div>
      <div class="main__content">
        <div class="crm">
          <aside class="crm__aside" style="width: 500px">
            <div v-if="property.contract" class="workspace_left__header" style="padding: 20px">
              <div class="workspace_left__row">
                <div class="workspace_left__item">
                  <span>Договор</span>
                </div>
                <div class="workspace_left__item">
                  <span>{{ property.contract.name || 'Нет данных' }}</span>
                </div>
              </div>
              <div v-if="property.contract.property_vin" class="workspace_left__row">
                <div class="workspace_left__item">
                  <span>VIN</span>
                </div>
                <div class="workspace_left__item">
                  <span>{{ property.contract.property_vin || 'Нет данных' }}</span>
                </div>
              </div>
              <div v-if="property.contract.property_sign" class="workspace_left__row">
                <div class="workspace_left__item">
                  <span>Подпись</span>
                </div>
                <div class="workspace_left__item">
                  <span>{{ property.contract.property_sign || 'Нет данных' }}</span>
                </div>
              </div>
            </div>
            <div v-if="property && property.info" style="padding: 20px" class="workspace_left__header">
              <div v-if="!property.contract" class="workspace_left__row">
                <div class="workspace_left__item">
                  <span>Договор</span>
                </div>
                <div class="workspace_left__item">
                  <span>{{ parseContract(property.title) || 'Нет данных' }}</span>
                </div>
              </div>
              <div
                class="workspace_left__row"
                v-for="(elem, index) in objToArrayObj(property.info)"
                :key="index"
              >
                <div class="workspace_left__item">
                  <div class="workspace_left__budget">
                    <span>{{ elem.title }}</span>
                  </div>
                </div>
                <div class="workspace_left__item">
                  <span>{{ elem.value }}</span>
                </div>
              </div>
            </div>
            <div v-if="property.info && property.info['Комментарий']" class="workspace_left__row" style="padding: 20px">
              <div class="workspace_left__item">
                <span>Комментарий: {{ property.info['Комментарий'] }}</span>
              </div>
            </div>
          </aside>
          <div class="images-container">
            <img
              class="images-container__image"
              v-for="image in property.images"
              :key="image"
              :src="`${baseURL}/api/seized-property/image?dir=${property.title}&filename=${image}`"
              :alt="image"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SeizedPropertiesSelected',
  data () {
    return {
      baseURL: process.env.VUE_APP_HTTP,
      property: null
    }
  },
  methods: {
    getName (contract, property) {
      if (contract && contract.name) return contract.name
      else if (property && property.info && property.info['Наименование']) return property.info['Наименование']
      else return 'Без наименования'
    },
    parseContract (str) {
      const regexp = /\[(.*?)\]/
      const matches = str.match(regexp)

      if (matches && matches.length > 1) {
        return matches[1]
      }
    },
    objToArrayObj (obj) {
      const keys = Object.keys(obj)
      const result = keys.map(key => {
        return {
          title: key,
          value: obj[key]
        }
      })
      return result
    }
  },
  async created () {
    const hash = this.$route.params.hash
    const response = await axios.get(`${this.baseURL}/api/seized-property/dir?hash=${hash}`)
    this.property = response.data
  }
}
</script>

<style lang="stylus" scoped>
.images-container
  width 100%

  display grid
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr))
  grid-gap 16px

  padding 15px

  &__image
    height 100%
    min-width 100%
    max-width 100%
    object-fit cover
    object-position center
</style>
